<div class="cm-skeleton-form-flat">
  <!-- Form fields without header or row structure - just stacked fields -->
  @for (item of [1, 2, 3, 4, 5]; track item) {
    <div class="cm-skeleton-form-flat-field">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 120px; margin-bottom: 0.5rem;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
    </div>
  }
</div>
